export default __webpack_public_path__ + "static/media/infoIcon.840455aa.svg";